/**
 * @Author: wuyang
 * @Date: 2024/1/8
 * @Description: ""
 */

import { RequestInstance } from '@/helper/request/requestInstance'
import { BASE_URL } from '@/constant'

export const requestInstance = new RequestInstance({
	baseUrl: BASE_URL,
	asyncInit: false
})
